/* lua.js generated code 0.3.0 */

var dc = null
cc.log("init dc >>>>>>>>>>>>>>")
dc = require("clover/dc/DCBase").getInstance()
cc.log("init dc DCBase >>>>>>>>>>>>>>")
require("clover/dc/DCAssist")
DCAssist.init()
cc.dc = global.dc = dc
